module.exports = {
      id: "tick-usage",
      viewBox: "0 0 23.788 23.787",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#tick",
      toString: function () {
        return this.url;
      }
    }